import cn from 'classnames'
import type { BookingError } from '@booking/types/booking'
import styles from './index.module.scss'

type ErrorBoxProps = {
  error: Pick<BookingError, 'message'> | { message: string }
}

export default function ErrorBox({ error }: ErrorBoxProps) {
  return <div className={cn(styles.error)}>{error.message}</div>
}
